// src/helpers/pdfOrdenCobro.js
import moment from "moment";
import { getOrdenCobroById, getOrdenCobroByNro } from "./rutaOrdenesCobro";

const money = (n) => Number(n || 0).toFixed(2);
const fmt = (d) => (d ? moment(d).format("DD/MM/YYYY") : "");

function openPrint(html) {
  const win = window.open("", "_blank");
  if (!win) {
    // Silencioso: no alert
    console.warn("Popup bloqueado por el navegador. Habilitá ventanas emergentes si querés imprimir.");
    return false;
  }
  win.document.open();
  win.document.write(html);
  win.document.close();
  return true;
}

function htmlFromOC(oc) {
  return `
    <html>
    <head>
      <meta charset="utf-8"/>
      <title>Orden de Cobro ${oc.nroOrdenCliente || oc._id}</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; }
        h2 { margin: 0 0 10px; }
        table { border-collapse: collapse; width: 100%; margin: 10px 0; }
        th, td { border: 1px solid #333; padding: 6px; font-size: 12px; }
        th { background: #eee; text-align: left; }
        .right { text-align: right; }
        .mt { margin-top: 14px; }
      </style>
    </head>
    <body>
      <h2>Orden de Cobro</h2>
      <div><b>N° Orden Cliente:</b> ${oc.nroOrdenCliente || ""}</div>
      <div><b>Fecha:</b> ${fmt(oc.fecha)} &nbsp; <b>Estado:</b> ${oc.estado || ""}</div>
      <div><b>Cliente:</b> ${oc.cliente?.razonsocial || ""} &nbsp; <b>CUIT:</b> ${oc.cliente?.cuit || ""}</div>
      ${oc.observaciones ? `<div><b>Observaciones:</b> ${oc.observaciones}</div>` : ""}

      <h3 class="mt">Aplicaciones</h3>
      <table>
        <thead><tr><th>Comanda</th><th>Viaje</th><th>Fecha</th><th class="right">Importe</th></tr></thead>
        <tbody>
          ${
            (oc.aplicaciones || [])
              .map(a => `
                <tr>
                  <td>#${String(a?.comanda?.codcom || "").padStart(6,"0")}</td>
                  <td>${a?.comanda?.nroviaje || ""}</td>
                  <td>${fmt(a?.comanda?.fecha)}</td>
                  <td class="right">$ ${money(a?.importe)}</td>
                </tr>
              `).join("") || `<tr><td colspan="4">—</td></tr>`
          }
        </tbody>
      </table>

      <h3 class="mt">Medios</h3>
      <table>
        <thead><tr><th>Tipo</th><th>Detalle</th><th class="right">Importe</th></tr></thead>
        <tbody>
          ${
            (oc.medios || [])
              .map(m => `
                <tr>
                  <td>${m.tipo || ""}</td>
                  <td>${[m.banco, m.numero, fmt(m.fecha)].filter(Boolean).join(" • ")}</td>
                  <td class="right">$ ${money(m.importe)}</td>
                </tr>
              `).join("") || `<tr><td colspan="3">—</td></tr>`
          }
        </tbody>
      </table>

      <h3 class="mt">Retenciones</h3>
      <table>
        <thead><tr><th>Tipo</th><th>N°</th><th>Fecha</th><th class="right">Importe</th></tr></thead>
        <tbody>
          ${
            (oc.retenciones || [])
              .map(r => `
                <tr>
                  <td>${r.tipo || ""}</td>
                  <td>${r.numero || ""}</td>
                  <td>${fmt(r.fecha)}</td>
                  <td class="right">$ ${money(r.importe)}</td>
                </tr>
              `).join("") || `<tr><td colspan="4">—</td></tr>`
          }
        </tbody>
      </table>

      <div class="mt">
        <b>Σ Aplicaciones:</b> $ ${money(oc.totalAplicaciones)} &nbsp;|&nbsp;
        <b>Σ Medios:</b> $ ${money(oc.totalMedios)} &nbsp;|&nbsp;
        <b>Σ Retenciones:</b> $ ${money(oc.totalRetenciones)}
      </div>

      <script>window.onload = () => { window.print(); };</script>
    </body>
    </html>
  `;
}

/**
 * Imprimir por objeto o por _id
 * - ocOrId: puede ser el objeto OC completo o el _id (string)
 * - options.silent: no mostrar alertas (default true)
 * Devuelve true/false
 */
export async function generarPDFOrdenCobro(ocOrId, options = {}) {
  const { silent = true } = options;
  try {
    let oc = null;

    if (ocOrId && typeof ocOrId === "object") {
      // ya me pasaron la OC completa
      oc = ocOrId;
    } else if (typeof ocOrId === "string") {
      // me pasaron un id => consulto
      const res = await getOrdenCobroById(ocOrId);
      if (res && res.ok) oc = res.ordenCobro || res.orden;
    }

    if (!oc) {
      if (!silent) console.warn("No se pudo obtener la Orden de Cobro.");
      return false;
    }

    return !!openPrint(htmlFromOC(oc));
  } catch (e) {
    if (!silent) console.warn("Error generando PDF OC:", e);
    return false;
  }
}

/** Opcional: imprimir por nro de orden del cliente */
export async function generarPDFOrdenCobroPorNro(nro, clienteId, options = {}) {
  const { silent = true } = options;
  try {
    const res = await getOrdenCobroByNro(nro, clienteId);
    const oc = res && res.ok ? (res.ordenCobro || res.orden) : null;
    if (!oc) {
      if (!silent) console.warn("No se encontró la Orden de Cobro.");
      return false;
    }
    return !!openPrint(htmlFromOC(oc));
  } catch (e) {
    if (!silent) console.warn("Error generando PDF OC por nro:", e);
    return false;
  }
}
